import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const SidebarHide18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M16.5303 3.53033L15.4697 2.46967L11.9393 6L15.4697 9.53033L16.5303 8.46967L14.0607 6L16.5303 3.53033Z'
      fill='currentColor'
    />
    <path d='M1 4.75H10V3.25H1V4.75Z' fill='currentColor' />
    <path d='M1 9.75H10V8.25H1V9.75Z' fill='currentColor' />
    <path d='M17 14.75H1V13.25H17V14.75Z' fill='currentColor' />
  </Svg>
);

SidebarHide18.displayName = 'SidebarHide18';
export default SidebarHide18;
